import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AUTH_ERROR, UPDATE_BODY_CSS} from "../../actions/types";
import {updateFavIconAttributes} from "../common/favIconAttributes/index";

const FavIconLoader = (props) => {
    const {orgImageUrl, favIconAttributes, orbitCssClass} = useSelector(state => state.logo);
    const dispatch = useDispatch();

    useEffect(async () => {
       //let link = document.querySelector("link[rel~='icon']");
        updateFavIconAttributes(orgImageUrl, orbitCssClass, favIconAttributes);
    }, [orgImageUrl, orbitCssClass, favIconAttributes]);

    return (
        props.children
    );
}

export default FavIconLoader;
